import { handleGetRequest } from "./GetTemplate";
import { handlePostRequest } from "./PostTemplate";

export const GATED_SHIFT_ROLES = ["clerk", "handler", "airportStaff", "driver"];

export const getCurrentPosition = () =>
    new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
            reject(new Error("Geolocation is not supported on this device"));
            return;
        }
        navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: false,
            timeout: 10000,
            maximumAge: 60000,
        });
    });

export const fetchShiftStatus = () => handleGetRequest("/shift/status");

export const clockIn = (dispatch, latitude, longitude, extra = {}) => dispatch(handlePostRequest({ latitude, longitude, ...extra }, "/shift/clock-in", true, true));

export const clockOut = (dispatch, latitude, longitude, extra = {}) => dispatch(handlePostRequest({ latitude, longitude, ...extra }, "/shift/clock-out", true, true));

export const logBreak = (dispatch, hours, note) => dispatch(handlePostRequest({ hours, note }, "/shift/break", true, true));

export const acquireRegister = (dispatch, cashRegisterId, startingCashUsd, startingCashJmd) =>
    dispatch(handlePostRequest({ cashRegisterId, startingCashUsd, startingCashJmd }, "/shift/register/acquire", true, true));

export const releaseRegister = (dispatch, closingCashUsd, closingCashJmd) =>
    dispatch(handlePostRequest({ closingCashUsd, closingCashJmd }, "/shift/register/release", true, true));

export const pingShiftLocation = (dispatch, latitude, longitude) => dispatch(handlePostRequest({ latitude, longitude }, "/shift/geo-ping", false, false));

export const fetchMyShiftHistory = (range, from, to) => {
    const params = new URLSearchParams();
    if (from && to) {
        params.set("from", from);
        params.set("to", to);
    } else if (range) {
        params.set("range", range);
    }
    const qs = params.toString();
    return handleGetRequest(`/shift/history${qs ? `?${qs}` : ""}`);
};

export const fetchAdminActiveShifts = () => handleGetRequest("/shift/admin/active");

export const fetchAdminPendingApprovals = () => handleGetRequest("/shift/admin/pending-approvals");

export const approveShift = (dispatch, id) => dispatch(handlePostRequest({}, `/shift/admin/${id}/approve`, true, true));

export const fetchAdminShiftById = (id) => handleGetRequest(`/shift/admin/${id}`);

export const fetchAdminShiftHistory = (staffId, range, from, to) => {
    const params = new URLSearchParams();
    if (staffId) params.set("staffId", staffId);
    if (from && to) {
        params.set("from", from);
        params.set("to", to);
    } else if (range) {
        params.set("range", range);
    }
    const qs = params.toString();
    return handleGetRequest(`/shift/admin/history${qs ? `?${qs}` : ""}`);
};

export const shiftStatusBadgeClass = (status) => {
    if (status === "active") return "badgeActive";
    if (status === "pending_approval") return "badgePending";
    return "badgeCompleted";
};

export const shiftStatusLabel = (status) => (status === "pending_approval" ? "Pending Approval" : status);

export const formatHours = (hours) => {
    if (hours === null || hours === undefined || isNaN(hours)) return "-";
    const totalMinutes = Math.round(hours * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${h}h ${m}m`;
};
